import { AutoComplete, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { calendarSpecialtyConsultationWebList } from "../../../../../../../services/calendarSpecialtyConsultationWeb.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutomationReceivedRulePreference.";

export const MedicalSpecialty = () => {
  const { t } = useTranslation();

  const { sendRequest: calendarSpecialtyConsultationWebListRequest } = useFetch(
    calendarSpecialtyConsultationWebList,
  );

  const [medicalSpecialtyLOptions, setMedicalSpecialtyOptions] =
    useState<ISelectType[]>();

  const fetchcalendarSpecialtyConsultationWebList = useCallback(async () => {
    const { data, success } =
      await calendarSpecialtyConsultationWebListRequest(null);
    if (data && success) {
      const newData = data.map((item) => ({
        id: item.identifier.toString(),
        name: item.name,
      }));
      setMedicalSpecialtyOptions(newData);
    }
  }, [calendarSpecialtyConsultationWebListRequest]);

  useEffect(() => {
    fetchcalendarSpecialtyConsultationWebList();
  }, [fetchcalendarSpecialtyConsultationWebList]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        name="medicalSpecialty"
        label={t(translationPath + "medical_specialty")}
        getOptionLabel={({ name }) => name}
        options={medicalSpecialtyLOptions}
        size="small"
      />
    </Grid>
  );
};
